import React, { useState } from "react";
import axios from "axios";
import illu from "./../../assets/images/illu/Contact-illu.png";
 
const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [recaptchaToken, setRecaptchaToken] = useState("");
 
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
 
  const handleSubmit = async (e) => {
    e.preventDefault();
 
    try {
      // Obtenir le token reCAPTCHA avant d'envoyer le formulaire
      const token = await window.grecaptcha.execute(
        "6LcJOKcqAAAAAGgqM4Mt21eDnomfhpQz0a8EV_jj",
        { action: "submit" }
      );
      setRecaptchaToken(token);
 
      if (!token) {
        alert("Veuillez compléter le reCAPTCHA.");
        return;
      }
 
      const response = await axios.post(
       "https://jppcompta.fr/send-email.php",
        { ...formData, recaptchaToken: token }
      );
      console.log(response.data);
      alert("Message envoyé avec succès!");
    } catch (error) {
      console.error(error);
      alert("Une erreur s'est produite. Veuillez réessayer.");
    }
  };
 
  return (
    <section className="Contact-container" id="contact">
      <article>
        <h2>
          Un doute ?
          <br /> Une question ?
          <br /> On est là <span className="blue">pour vous.</span>
        </h2>
 
        <div>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="Nom"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              placeholder="Email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <input
              placeholder="Message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
            />
            <button type="submit" className="btn">
              Envoyer <svg xmlns="http://www.w3.org/2000/svg" className="arrow-icon white" viewBox="0 0 448 512"><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"/></svg>
            </button>
          </form>
 
          <p>
            <a
              href="https://maps.app.goo.gl/YSFfXiehojSnP5da7"
              target="_blank"
              rel="noreferrer"
              className="whiteLink"
            >
              14 avenue Georges Clémenceau, 06000 NICE
            </a>
            <br />
            <br />
            <a
              href="tel:+33668318132"
              target="_blank"
              rel="noreferrer"
              className="whiteLink"
            >
              T / +33 (0)6 68 31 81 32
            </a>
            <br />
            <a
              href="mailto:contact@jppcompta.fr"
              target="_blank"
              rel="noreferrer"
              className="whiteLink"
            >
              E / contact@jppcompta.fr
            </a>
            <br />
            <br />
            Lundi / vendredi
            <br /> 08h00 - 17h00
          </p>
        </div>
      </article>
      <img className="img-illu" src={illu} alt="illustration" />
    </section>
  );
};
 
export default Contact;